import {
  createExpressionValidator,
  ValidationResult,
} from '@ac/react-infrastructure';

export const createNumericStringValidator = (
  message: string
): ((value?: string | undefined) => ValidationResult) =>
  createExpressionValidator(message, /^-?\d+$/g);
